export const isNewProductRoute = (id?: string): boolean => !id || id === "new";

export const toNumberOrNull = (value: string): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

export type SkuComponentType = "gift" | "set_item";

export const normalizeSkuComponentType = (value?: string): SkuComponentType =>
  value === "set_item" ? "set_item" : "gift";

export const normalizeSkuWholesale = (value: boolean | undefined, legacyProductValue: boolean): boolean =>
  value ?? legacyProductValue;
